// Core packages
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Third party packages

// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';

// Custom packages - Component
import { GasMetersListComponent } from 'src/app/modules/gas-meters/pages/gas-meters-list/gas-meters-list.page';

const routes: Routes = [
  {
    path: 'list',
    component: GasMetersListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadPropertiesList']
    },
  },
  {
    path: '**',
    redirectTo: 'it/errors/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class GasMetersRoutingModule { }
